module.exports = __webpack_public_path__ + "static/media/dine.6210fa40.png";